export const primaryColor = "#ffc515";
export const secondaryColor = "#d6d6d6";
export const darkColor = "#212121";
export const darkSecondaryColor = "#2e2e2e";
export const linkColor = "#007aff";
